import { SelectItem } from '../types/locationTypes'

const getAttendantSeatOptions = (): SelectItem[] => {
    return [
        {
            text: '0',
            value: '0',
            selected: false,
            disabled: false
        },
        {
            text: '1',
            value: '1',
            selected: false,
            disabled: false
        },
        {
            text: '2',
            value: '2',
            selected: false,
            disabled: false
        },
        {
            text: '3',
            value: '3',
            selected: false,
            disabled: false
        },
        {
            text: '4',
            value: '4',
            selected: false,
            disabled: false
        },
        {
            text: '5',
            value: '5',
            selected: false,
            disabled: false
        },
    ]
}

const getStretcherOptions = (): SelectItem[] => {
    return [
        {
            text: '0',
            value: '0',
            selected: false,
            disabled: false
        },
        {
            text: '1',
            value: '1',
            selected: false,
            disabled: false
        },
        {
            text: '2',
            value: '2',
            selected: false,
            disabled: false
        },
        {
            text: '3',
            value: '3',
            selected: false,
            disabled: false
        },
        {
            text: '4',
            value: '4',
            selected: false,
            disabled: false
        },
    ]
}

const getAcuityOptions = (): SelectItem[] => {
    return [
        {
            text: 'A',
            value: 'A',
            selected: false,
            disabled: false
        },
        {
            text: 'B',
            value: 'B',
            selected: false,
            disabled: false
        },
        {
            text: 'C',
            value: 'C',
            selected: false,
            disabled: false
        },
        {
            text: 'D',
            value: 'D',
            selected: false,
            disabled: false
        },
        {
            text: 'E',
            value: 'E',
            selected: false,
            disabled: false
        },
        {
            text: 'H',
            value: 'H',
            selected: false,
            disabled: false
        },
        {
            text: 'M',
            value: 'M',
            selected: false,
            disabled: false
        },
        {
            text: 'L',
            value: 'L',
            selected: false,
            disabled: false
        },
    ]
}

const getMultiloadAllowedOptions = (): SelectItem[] => {
    return [
        {
            text: 'No',
            value: 'No',
            selected: false,
            disabled: false
        },
        {
            text: 'Yes',
            value: 'Yes',
            selected: false,
            disabled: false
        }
    ]
}
const getsharingroleOptions = (): SelectItem[] => {
    return [
        {
            text: 'Primary',
            value: 'Primary',
            selected: false,
            disabled: false
        },
        {
            text: 'Secondary',
            value: 'Secondary',
            selected: false,
            disabled: false
        }
    ]
}
const getMultiloadCapabilityOptions = (): SelectItem[] => {
    return [
        {
            text: '1',
            value: '1',
            selected: false,
            disabled: false
        },
        {
            text: '2',
            value: '2',
            selected: false,
            disabled: false
        },
        {
            text: '3',
            value: '3',
            selected: false,
            disabled: false
        },
        {
            text: '4',
            value: '4',
            selected: false,
            disabled: false
        },
    ]
}
const getServicedByOptions = (): SelectItem[] => {
    return [
        {
            text: 'SMA Fleet',
            value: '1',
            selected: false,
            disabled: false,
        },
        {
            text: 'Customer Fleet',
            value: '2',
            selected: false,
            disabled: false,
        },
    ]
}
const getPricingByOptions = (): SelectItem[] => {
    return [
        {
            text: 'Per Transfer',
            value: '1',
            selected: false,
            disabled: false
        },
        {
            text: 'Per Shift',
            value: '2',
            selected: false,
            disabled: false
        },
    ]
}
const tooltips = {
    noOfStretchers: 'Number of stretchers assumed to be in vehicles servicing this schedule.',
    noOfPatientSeats: 'Number of attendant seats assumed to be in vehicles servicing this schedule. Attendant seats are those available for patients or their companions.',
    maxPatientAcuity: 'The maximum (most acute) acuity of patients that can be added to this schedule.',
    noOfPickupDropoffs: 'Indicates whether dropoffs and pickups for multiple-loaded trips against this schedule are assumed to be able to be carried out in parallel. This affects our time estimates',
    isMutliloadAllowed: 'Trips on this schedule are allowed to include multiple patients.',
    schedulingLeadTtime: 'Prevents trips being scheduled with too little notice. Trips cannot be scheduled within this amount of time from now.',
    servicedBy: 'Sets whether this planner will be serviced by SMA vehicles or the customer’s own vehicles',
    pricing:'Determines whether per-transfer pricing is calculated for transfers scheduled through this planner'
}

const plannerSectionDescription = 'Add planners to allow customers to schedule their own trips. Each planner represents a virtual vehicle that limits the number and type of transfers that can be scheduled';

export {
    getAttendantSeatOptions,
    getStretcherOptions,
    getAcuityOptions,
    getMultiloadAllowedOptions,
    getMultiloadCapabilityOptions,
    getsharingroleOptions,
    getServicedByOptions,
    getPricingByOptions,
    tooltips,
    plannerSectionDescription
}